<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Gráficos y Estadísticas
  </h1>
  <h2 class="main-subtitle mb-2">Informes para clientes</h2>

  <div class="single-page-content">
    <div class="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mb-4">
      <a routerLink="/container-report">
        <div class="button-card">
          <div class="icon-box">
            <img src="assets/icons/info-icon.svg" alt="">
          </div>
          <div class="text-box">
            Informe por envase
          </div>
        </div>
      </a>

      <a routerLink="/customer-report">
        <div class="button-card">
          <div class="icon-box">
            <img src="assets/icons/info-icon.svg" alt="">
          </div>
          <div class="text-box">
            Informe por cliente
          </div>
        </div>
      </a>

    </div>
  </div>
</div>
  